
<template>
    <b-modal
        v-model="visible"
        size="xl"
        hide-footer
        hide-header-close
        centered
        @hidden="$emit('hidden')"
    >
      <div class="add_modal">
        <div class="add_modal__body">
          <!-- Блок отправителя (режимы с отправителем, см. isSenderMode) -->
          <div v-if="isSenderMode" class="isgp-sender-block">
            <div class="isgp-sender-block__field">
              <label class="isgp-sender-block__label">
                {{ setText('isgp_sender.org_code') }} <span class="text-danger">*</span>
              </label>
              <b-form-select
                  v-model="senderOrgCode"
                  :options="senderOrgOptions"
              ></b-form-select>
              <div v-if="senderOrgsLoaded && !senderOrgs.length" class="isgp-sender-block__error">
                {{ setText('isgp_sender.org_not_found') }}
              </div>
            </div>
            <div class="isgp-sender-block__field">
              <label class="isgp-sender-block__label">
                {{ setText('isgp_sender.user') }} <span class="text-danger">*</span>
              </label>
              <multiselect
                  v-model="senderUser"
                  :options="senderUsers"
                  track-by="userId"
                  label="fio"
                  :searchable="true"
                  :internal-search="false"
                  :loading="senderUsersLoading"
                  :disabled="!senderOrgCode"
                  :show-labels="false"
                  :allow-empty="true"
                  :clear-on-select="false"
                  :preserve-search="false"
                  :placeholder="setText('isgp_sender.user_placeholder')"
                  @search-change="onSenderUserSearch"
              >
                <template slot="option" slot-scope="{ option }">
                  <div class="isgp-sender-user-option">
                    <div>{{ option.fio }}</div>
                    <div class="isgp-sender-user-option__org">{{ selectedSenderOrgLabel }}</div>
                  </div>
                </template>
                <template slot="noResult">{{ setText('isgp_sender.user_not_found') }}</template>
                <template slot="noOptions">{{ setText('isgp_sender.user_not_found') }}</template>
              </multiselect>
              <small class="text-muted d-block">{{ setText('isgp_sender.user_hint') }}</small>
            </div>
          </div>
          <div class="table-container b-table-sticky-header scrolable">
            <div  v-if="isMSU || isAbpMode || isAbpByExpenseMode"
                  style="display: flex; justify-content: space-between; gap: 20px">
              <b-tabs class="tabs-in-tabs">
                <b-tab>
                  <template #title align="left">
                    <button class="icon-btn" @click="addModalToglerOpen(addModalTogler.requestABP, 'requestABP')">
                      <i class="icon icon-keyboard icon-rotate-270" v-if="addModalTogler.requestABP"></i>
                      <i class="icon icon-keyboard icon-rotate-90" v-else></i>
                    </button>
                    <span class="ml-2">
                      {{ callerTabTitle }}
                    </span>
                  </template>
                  <table class="table b-table table-hover table-bordered table-sm b-table-no-border-collapse">
                    <thead>
                    <tr>
                      <th :style="{ width: field.thStyle.width }" v-for="field in larTableFields" :key="field.key">
                        <template>
                          {{ fieldLabel(field, false) }}
                        </template>
                      </th>
                    </tr>
                    </thead>
                    <tbody v-if="addModalTogler.requestABP">
                    <tr v-for="ref in readyABPList" :key="ref.id">
                        <td>
                          <b-form-checkbox v-model="ref.check"
                                           @change="handleSingleSelect(readyABPList, ref)"
                                           :disabled="isAbpMode"
                          ></b-form-checkbox>
                        </td>
                        <td>
                          <b-form-input
                              v-if="isSenderMode"
                              type="number"
                              min="1"
                              step="1"
                              size="sm"
                              v-model="ref.number"
                              class="isgp-editable-input"
                          ></b-form-input>
                          <template v-else>
                            {{ ref.number }}
                          </template>
                        </td>
                        <td>
                          <date-picker
                              v-model="ref.agreementDate"
                              format="DD.MM.YYYY"
                              type="date"
                              :editable="false"
                              :disabled-date="disabledDate"
                              :placeholder="setText('date_select')"
                              input-class="isgp-editable-date-input"
                              style="width: 100%"
                          ></date-picker>
                        </td>
                        <td>
                          <date-picker
                              v-model="ref.requestDate"
                              format="DD.MM.YYYY"
                              type="date"
                              :editable="false"
                              :disabled-date="disabledDate"
                              :placeholder="setText('date_select')"
                              input-class="isgp-editable-date-input"
                              style="width: 100%"
                          ></date-picker>
                        </td>
                        <td>
                          {{ getRequestType(ref) }}
                        </td>
                        <td>
                          <b-form-input
                              v-if="isSenderMode"
                              type="text"
                              maxlength="255"
                              size="sm"
                              v-model="ref.description"
                              class="isgp-editable-input"
                          ></b-form-input>
                          <template v-else>
                            {{ ref.description }}
                          </template>
                        </td>
                    </tr>
                    <tr v-if="abpEmptyHint">
                        <td :colspan="larTableFields.length" class="text-muted text-center">
                          {{ abpEmptyHint }}
                        </td>
                    </tr>
                    </tbody>
                  </table>
                </b-tab>
              </b-tabs>
            </div>
            <div v-if="!isAbpMode"
                 style="display: flex; justify-content: space-between; gap: 20px">
              <b-tabs class="tabs-in-tabs">
                <b-tab>
                  <template #title align="left">
                    <button class="icon-btn" @click="addModalToglerOpen(addModalTogler.reference_expenses, 'reference_expenses')">
                      <i class="icon icon-keyboard icon-rotate-270" v-if="addModalTogler.reference_expenses"></i>
                      <i class="icon icon-keyboard icon-rotate-90" v-else></i>
                    </button>
                    <span class="ml-2">
                        {{ setText('expenses') }}
                    </span>
                  </template>
                  <table class="table b-table table-hover table-bordered table-sm b-table-no-border-collapse">
                    <thead>
                    <tr>
                      <th :style="{ width: field.thStyle.width }" v-for="field in larTableFields" :key="field.key">
                        <template>
                          {{ fieldLabel(field, false) }}
                        </template>
                      </th>
                    </tr>
                    </thead>
                    <tbody v-if="addModalTogler.reference_expenses">
                    <tr v-for="ref in readyExpensesList" :key="ref.id">
                        <td>
                          <b-form-checkbox v-model="ref.check"
                                           @change="handleSingleSelect(readyExpensesList, ref)"
                                           :disabled="callerTab === 'reference_expenses'"
                          ></b-form-checkbox>
                        </td>
                        <td>
                          <b-form-input
                              v-if="isSenderMode"
                              type="number"
                              min="1"
                              step="1"
                              size="sm"
                              v-model="ref.number"
                              class="isgp-editable-input"
                          ></b-form-input>
                          <template v-else>
                            {{ ref.number }}
                          </template>
                        </td>
                        <td>
                          <date-picker
                              v-model="ref.agreementDate"
                              format="DD.MM.YYYY"
                              type="date"
                              :editable="false"
                              :disabled-date="disabledDate"
                              :placeholder="setText('date_select')"
                              input-class="isgp-editable-date-input"
                              style="width: 100%"
                          ></date-picker>
                        </td>
                        <td>
                          <date-picker
                              v-model="ref.requestDate"
                              format="DD.MM.YYYY"
                              type="date"
                              :editable="false"
                              :disabled-date="disabledDate"
                              :placeholder="setText('date_select')"
                              input-class="isgp-editable-date-input"
                              style="width: 100%"
                          ></date-picker>
                        </td>
                        <td>
                          {{ getRequestType(ref) }}
                        </td>
                        <td>
                          <b-form-input
                              v-if="isSenderMode"
                              type="text"
                              maxlength="255"
                              size="sm"
                              v-model="ref.description"
                              class="isgp-editable-input"
                          ></b-form-input>
                          <template v-else>
                            {{ ref.description }}
                          </template>
                        </td>
                    </tr>
                    </tbody>
                  </table>
                </b-tab>
              </b-tabs>
            </div>
            <div v-if="!isAbpMode"
                 style="display: flex; justify-content: space-between; gap: 20px">
              <b-tabs class="tabs-in-tabs">
                <b-tab>
                  <template #title align="left">
                    <button class="icon-btn" @click="addModalToglerOpen(addModalTogler.reference_income, 'reference_income')">
                      <i class="icon icon-keyboard icon-rotate-270" v-if="addModalTogler.reference_income"></i>
                      <i class="icon icon-keyboard icon-rotate-90" v-else></i>
                    </button>
                    <span class="ml-2">
                        {{ setText('income') }}
                    </span>
                  </template>
                  <table class="table b-table table-hover table-bordered table-sm b-table-no-border-collapse">
                    <thead>
                    <tr>
                      <th :style="{ width: field.thStyle.width }" v-for="field in larTableFields" :key="field.key">
                        <template>
                          {{ fieldLabel(field, false) }}
                        </template>
                      </th>
                    </tr>
                    </thead>
                    <tbody v-if="addModalTogler.reference_income">
                    <tr v-for="ref in readyIncomeList" :key="ref.id">
                        <td>
                          <b-form-checkbox v-model="ref.check"
                                           @change="handleSingleSelect(readyIncomeList, ref)"
                                           :disabled="callerTab === 'reference_income'"
                          ></b-form-checkbox>
                        </td>
                        <td>
                          <b-form-input
                              v-if="isSenderMode"
                              type="number"
                              min="1"
                              step="1"
                              size="sm"
                              v-model="ref.number"
                              class="isgp-editable-input"
                          ></b-form-input>
                          <template v-else>
                            {{ ref.number }}
                          </template>
                        </td>
                        <td>
                          <date-picker
                              v-model="ref.agreementDate"
                              format="DD.MM.YYYY"
                              type="date"
                              :editable="false"
                              :disabled-date="disabledDate"
                              :placeholder="setText('date_select')"
                              input-class="isgp-editable-date-input"
                              style="width: 100%"
                          ></date-picker>
                        </td>
                        <td>
                          <date-picker
                              v-model="ref.requestDate"
                              format="DD.MM.YYYY"
                              type="date"
                              :editable="false"
                              :disabled-date="disabledDate"
                              :placeholder="setText('date_select')"
                              input-class="isgp-editable-date-input"
                              style="width: 100%"
                          ></date-picker>
                        </td>
                        <td>
                          {{ getRequestType(ref) }}
                        </td>
                        <td>
                          <b-form-input
                              v-if="isSenderMode"
                              type="text"
                              maxlength="255"
                              size="sm"
                              v-model="ref.description"
                              class="isgp-editable-input"
                          ></b-form-input>
                          <template v-else>
                            {{ ref.description }}
                          </template>
                        </td>
                    </tr>
                    </tbody>
                  </table>
                </b-tab>
              </b-tabs>
            </div>
            <div v-if="!isAbpMode"
                 style="display: flex; justify-content: space-between; gap: 20px">
              <b-tabs class="tabs-in-tabs">
                <b-tab>
                  <template #title align="left">
                    <button class="icon-btn" @click="addModalToglerOpen(addModalTogler.refined_plan, 'refined_plan')">
                      <i class="icon icon-keyboard icon-rotate-270" v-if="addModalTogler.refined_plan"></i>
                      <i class="icon icon-keyboard icon-rotate-90" v-else></i>
                    </button>
                    <span class="ml-2">
                        {{ setText('refined_plan') }}
                    </span>
                  </template>
                  <table class="table b-table table-hover table-bordered table-sm b-table-no-border-collapse">
                    <thead>
                    <tr>
                      <th :style="{ width: field.thStyle.width }" v-for="field in larTableFields" :key="field.key">
                        <template>
                          {{ fieldLabel(field, true) }}
                        </template>
                      </th>
                    </tr>
                    </thead>
                    <tbody v-if="addModalTogler.refined_plan">
                    <tr v-for="ref in readyUtochList" :key="ref.id">
                        <td>
                          <b-form-checkbox v-model="ref.check"
                                           @change="handleSingleSelect(readyUtochList, ref)"
                                           :disabled="callerTab === 'refined_plan'"
                          ></b-form-checkbox>
                        </td>
                        <td>
                          <b-form-input
                              v-if="isSenderMode"
                              type="number"
                              min="1"
                              step="1"
                              size="sm"
                              v-model="ref.number"
                              class="isgp-editable-input"
                          ></b-form-input>
                          <template v-else>
                            {{ ref.number }}
                          </template>
                        </td>
                        <td>
                          <date-picker
                              v-model="ref.agreementDate"
                              format="DD.MM.YYYY"
                              type="date"
                              :editable="false"
                              :disabled-date="disabledDate"
                              :placeholder="setText('date_select')"
                              input-class="isgp-editable-date-input"
                              style="width: 100%"
                          ></date-picker>
                        </td>
                        <td>
                          <date-picker
                              v-model="ref.requestDate"
                              format="DD.MM.YYYY"
                              type="date"
                              :editable="false"
                              :disabled-date="disabledDate"
                              :placeholder="setText('date_select')"
                              input-class="isgp-editable-date-input"
                              style="width: 100%"
                          ></date-picker>
                        </td>
                        <td>
                          {{ getRequestType(ref) }}
                        </td>
                        <td>
                          <b-form-input
                              v-if="isSenderMode"
                              type="text"
                              maxlength="255"
                              size="sm"
                              v-model="ref.description"
                              class="isgp-editable-input"
                          ></b-form-input>
                          <template v-else>
                            {{ ref.description }}
                          </template>
                        </td>
                    </tr>
                    </tbody>
                  </table>
                </b-tab>
              </b-tabs>
            </div>
          </div>
        </div>
      </div>

      <div class="add_modal__footer">
        <b-button variant="primary" :disabled="!canSend" @click="onSend">{{ setText('send') }}</b-button>
        <b-button variant="secondary" @click="onClose">{{ setText('cancel') }}</b-button>
       </div>
    </b-modal>
</template>

<script>
import AlterationI18nMixin from "@/modules/budget/alteration/mixins/alteration-i18n-mixin";
import i18nService from "@/services/i18n";
import moment from "moment";
import DatePicker from "vue2-datepicker";
import { Ax } from "@/utils";

// Приведение ответа sender-gu к [{ code, nameRu, nameKk, abp }]: формат ответа бэка не подтверждён —
// может прийти массив объектов, один объект или код строкой/числом, поэтому разбираем все варианты
function toSenderOrgList(data) {
  const list = Array.isArray(data) ? data : (data !== null && data !== undefined && data !== '' ? [data] : []);
  return list
      .map(item => {
        if (typeof item === 'string' || typeof item === 'number') {
          return { code: String(item), nameRu: '', nameKk: '', abp: null };
        }
        const code = item.code || item.orgCode || item.guCode || item.gu;
        return {
          code: code ? String(code) : '',
          nameRu: item.nameRu || item.name_ru || item.name || '',
          nameKk: item.nameKk || item.name_kk || item.nameKz || item.name_kz || '',
          // АБП, которому принадлежит ГУ: по нему отбираются заявки/справки АБП (СВИ ИПФ) в справке (расходы)
          abp: item.abp ? String(item.abp) : null
        };
      })
      .filter(item => item.code);
}
// Приведение ответа sender-employees к [{ userId, fio }]: формат полей не подтверждён;
// ИИН (если бэк его вернёт) не используется и не выводится
function toSenderUserList(data) {
  return (Array.isArray(data) ? data : [])
      .map(item => ({
        userId: item.userId || item.id,
        fio: item.fio || item.fullName || item.name
            || [item.lastName || item.lastname, item.firstName || item.firstname, item.patronymicName || item.patronymicname || item.middleName]
                .filter(Boolean).join(' ')
      }))
      .filter(item => item.userId);
}

export default {
    name: "CAlterationSelectModal",
    components: { DatePicker },
    mixins: [AlterationI18nMixin],
    props: {
        show: {
            type: Boolean,
            default: false
        },
        // Проверка на отдел МСУ (можно передавать из родителя или вычислять здесь)
        isMSU: {
            type: Boolean,
            default: false
        },
        callerTab: {
          type: String,
          default: '' // Передаем 'requestABP', 'reference_expenses' или 'reference_income'
        },
        currentAlteration: {
          type: Object,
          default: () => null
        },
        accessLevels: {
          type: Object,
          default: () => ({ position: 'UF' })
        },
        requestTypeOptions: {}

    },
    data() {
        return {
          addModalTogler: {
              requestABP: true,
              reference_expenses: true,
              reference_income: true,
              refined_plan: true,
            },
          listExpenses: [],
          listIncome: [],
          listUtoch: [],
          listABP: [],
          larTableFields: [
            { key: 'check', label: '', thStyle: { width: "5%" } },
            { key: 'number', label: 'Номер', name_ru: 'Номер', name_kk: 'Саны', thStyle: { width: "10%" } },
            // Лейблы для agreementDate/requestDate вычисляются через fieldLabel() (i18n, зависят от секции реестра)
            { key: 'agreementDate', label: '', thStyle: { width: "15%" } },
            { key: 'requestDate', label: '', thStyle: { width: "15%" } },
            { key: 'requestType', label: 'Вид справки', name_ru: 'Вид справки', name_en: 'Type of reference', name_kk: 'Анықтаманың түрі', thStyle: { width: "20%" } },
            { key: 'description', label: 'Основание', name_ru: 'Основание', name_en: 'Base', name_kk: 'Негіз', thStyle: { width: "35%" } }
          ],
          // Отправитель (режим АБП): ГУ-отправитель и сотрудник, от чьего имени отправляется в ИС КК
          senderOrgs: [],
          senderOrgCode: null,
          senderOrgsLoaded: false,
          senderUsers: [],
          senderUser: null,
          senderUsersLoading: false,
          senderUserSearchTimer: null,
          senderUserSearchSeq: 0,
          // Флаг отправки на сервер (блокирует повторные нажатия кнопки "Отправить")
          sending: false,
        };
    },
    watch: {
        show(val) {
          this.visible = val;
          if (val) {
              this.loadData();
              if (this.isSenderMode) {
                // при каждом открытии модалки в режимах с отправителем состояние отправителя сбрасывается и загружается заново
                this.resetSenderState();
                this.loadSenderOrgs();
              }
            }
        },
        visible(newVal) {},
        // при смене справки (расходы) состав заявок/справок АБП меняется — снимаем с них отметки
        abpParentExpenseId() {
          this.uncheckAbpByExpenseList();
        },
        // при смене АБП ГУ-отправителя заявки/справки АБП фильтруются заново — снимаем с них отметки
        selectedSenderOrgAbp() {
          this.uncheckAbpByExpenseList();
        },
        // при выборе/смене ГУ-отправителя сбрасываем выбранного сотрудника и загружаем список заново
        senderOrgCode(newVal) {
          this.senderUser = null;
          this.senderUsers = [];
          if (newVal) {
            this.loadSenderUsers('');
          }
        }
    },
    mounted() {
    },
    beforeDestroy() {
      clearTimeout(this.senderUserSearchTimer);
    },
    computed: {
      visible: {
        get() {
          return this.show;
        },
        set(value) {
          this.$emit('shown', value);
        }
      },
      // Режим "Заявки АБП"/"Справки АБП": показывается только текущая заявка, номер/основание редактируемы, нужен отправитель
      isAbpMode() {
        return ['requestABP', 'referenceABP'].includes(this.callerTab);
      },
      // Режим "Справки (расходы)"
      isExpensesMode() {
        return this.callerTab === 'reference_expenses';
      },
      // Режимы, где заявки/справки АБП показываются по справке (расходы): в расходах — по открытой справке,
      // в доходах и уточнённом плане — по справке, отмеченной в блоке "Расходы"
      isAbpByExpenseMode() {
        return ['reference_expenses', 'reference_income', 'refined_plan'].includes(this.callerTab);
      },
      // id справки (расходы), в которую входят показываемые заявки/справки АБП (null — справка не выбрана)
      abpParentExpenseId() {
        if (this.isExpensesMode) {
          return this.currentAlteration ? this.currentAlteration.id : null;
        }
        const checked = this.readyExpensesList.find(item => item.check);
        return checked ? checked.id : null;
      },
      // Подсказка в пустом блоке заявок/справок АБП, когда его состав зависит от справки (расходы) и ГУ-отправителя
      abpEmptyHint() {
        if (!this.isAbpByExpenseMode || this.readyABPList.length) return '';
        if (this.abpParentExpenseId === null) return this.setText('abp_by_expense.select_expense');
        if (!this.senderOrgCode) return this.setText('abp_by_expense.select_sender');
        if (this.selectedSenderOrgAbp === null) return this.setText('abp_by_expense.sender_no_abp');
        return this.$t('modules.budget_execution_alteration.abp_by_expense.empty', { abp: this.selectedSenderOrgAbp });
      },
      // Режимы с выбором отправителя и редактируемыми номером/основанием:
      // заявки/справки АБП, справки (расходы), справки (доходы) и уточнённый план
      isSenderMode() {
        return this.isAbpMode || ['reference_expenses', 'reference_income', 'refined_plan'].includes(this.callerTab);
      },
      callerTabTitle: function () {
          const tabTitleMap = {
              'requestABP': this.setText('requestABP'),
              'referenceABP': this.setText('referenceABP')
          };
          return tabTitleMap[this.callerTab] || this.setText('requestABP');
      },
      callerTabStatus: function () {
          const tabStatusMap = {
              'requestABP': 32,
              'referenceABP': 26
          };
          return tabStatusMap[this.callerTab] || 32;
      },
      readyUtochList() {
        const now = new Date();
        return (this.listUtoch || []).filter(item => new Date(item.date) <= now);
      },
      readyIncomeList() {
        const now = new Date();
        return (this.listIncome || []).filter(item => new Date(item.date) <= now);
      },
      readyExpensesList() {
        const now = new Date();
        return (this.listExpenses || []).filter(item => new Date(item.date) <= now);
      },
      readyABPList() {
        const now = new Date();
        const list = (this.listABP || []).filter(item => new Date(item.date) <= now);
        if (!this.isAbpByExpenseMode) return list;
        // СВИ ИПФ ГУ-отправителя: заявки/справки АБП, вошедшие в справку (расходы) (parent = id справки),
        // по АБП выбранного ГУ-отправителя
        const parentId = this.abpParentExpenseId;
        const senderAbp = this.selectedSenderOrgAbp;
        if (parentId === null || senderAbp === null) return [];
        return list.filter(item => item.parent !== null && item.parent !== undefined
            && Number(item.parent) === Number(parentId)
            && item.abp !== null && item.abp !== undefined
            && Number(item.abp) === Number(senderAbp));
      },
      // Опции b-form-select для ГУ-отправителя: первая опция - неактивный плейсхолдер
      senderOrgOptions() {
        const options = [
          { value: null, text: this.setText('isgp_sender.org_select'), disabled: true }
        ];
        for (const org of this.senderOrgs || []) {
          const name = i18nService.locale === 'kk' ? (org.nameKk || org.nameRu) : org.nameRu;
          options.push({ value: org.code, text: name ? `${org.code} — ${name}` : org.code });
        }
        return options;
      },
      // Наименование выбранного ГУ-отправителя (для подписи организации в списке сотрудников)
      selectedSenderOrgName() {
        const org = (this.senderOrgs || []).find(item => item.code === this.senderOrgCode);
        if (!org) return '';
        return i18nService.locale === 'kk' ? (org.nameKk || org.nameRu) : org.nameRu;
      },
      // АБП выбранного ГУ-отправителя (null — ГУ не выбран или у него не указан АБП)
      selectedSenderOrgAbp() {
        const org = (this.senderOrgs || []).find(item => item.code === this.senderOrgCode);
        return org && org.abp ? org.abp : null;
      },
      // Подпись организации в списке сотрудников: без наименования - только код, иначе "наименование (код)"
      selectedSenderOrgLabel() {
        const name = this.selectedSenderOrgName;
        return name ? `${name} (${this.senderOrgCode})` : String(this.senderOrgCode || '');
      },
      // Кнопка "Отправить" активна, пока не идёт отправка; в режимах с отправителем дополнительно нужны ГУ и сотрудник
      canSend() {
        return !this.sending && (!this.isSenderMode || (Boolean(this.senderOrgCode) && Boolean(this.senderUser)));
      }
    },
    methods: {
      // Лейбл колонки с датой: для реестра "Уточ.план" (isUtoch) используется формулировка про решение сессии маслихата
      fieldLabel(field, isUtoch) {
        if (field.key === 'agreementDate') {
          return isUtoch ? this.setText('maslikhat_decision_date') : this.setText('application_date');
        }
        if (field.key === 'requestDate') {
          return this.setText('certificate_date');
        }
        return field.label;
      },
      // ограничение выбора даты: недоступны даты раньше 1 января текущего года и позже сегодняшнего дня (сегодня включительно)
      disabledDate(date) {
        const now = new Date();
        const yearStart = new Date(now.getFullYear(), 0, 1);
        const todayEnd = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59, 999);
        return date < yearStart || date > todayEnd;
      },
      isDateAllowed(date) {
        return Boolean(date) && !this.disabledDate(new Date(date));
      },
      getRequestType(ref) {
        const code = ref.requestType;
        if (!code) return '';

        // Специальное форматирование для уточненного бюджета
        if (code === 'budget_utoch') {
          return `${this.setText('revised_budget')} №${ref.number || ''}`;
        }

        // Если опции не переданы, возвращаем код как есть
        if (!this.requestTypeOptions || this.requestTypeOptions.length === 0) return code;

        const found = this.requestTypeOptions.find(item => (item.code || item.value) === code);
        if (found) {
          const locale = i18nService.locale;
          if (locale === 'kk') return found.name_kk || code;
          if (locale === 'en') return found.name_en || code;
          return found.name_ru || found.label || code;
        }
        return code;

      },
      addModalToglerOpen(value, key) {
        this.$set(this.addModalTogler, key, !value);
      },
      // Элемент списка модалки: флаг выбора, даты по умолчанию и исходные номер/основание (для определения изменений перед отправкой)
      toSelectableItem(item) {
        return { ...item, check: false, agreementDate: new Date(), requestDate: new Date(), originalNumber: item.number, originalDescription: item.description };
      },
      async loadData() {
        if (!this.currentAlteration || !this.currentAlteration.region) return;
        const regionCode = this.currentAlteration.region;

        const dateFrom = moment(this.currentAlteration.date).startOf('year').format('YYYY-MM-DD');
        const dateTo = moment().format('YYYY-MM-DD');
        const year = moment(this.currentAlteration.date).year();
        try {
          // Справки расходов
          let response = await fetch(
              `/api/budget-execution-alteration-uf-request/list?region=${regionCode}&dateBegin=${dateFrom}&dateEnd=${dateTo}`
          );
          const expenseData = await response.json();
          this.listExpenses = expenseData
              .filter(item => {
                // Проверяем статус (может быть как числом, так и объектом со свойством id)
                const statusId = (item.status && typeof item.status === 'object') ? item.status.status : item.status;
                return statusId === 26;
              })
              .sort((a, b) => {
                // Сортировка по дате
                return new Date(a.date) - new Date(b.date);
              })
              .map(i => this.toSelectableItem(i));
          // Справки доходов
          response = await fetch(
              `/api/budget-execution-alteration-uf-request/list?region=${regionCode}&dateBegin=${dateFrom}&dateEnd=${dateTo}&isIncome=true`
          );
          const incomeData = await response.json();
          this.listIncome = incomeData
              .filter(item => {
                // Проверяем статус (может быть как числом, так и объектом со свойством id)
                const statusId = (item.status && typeof item.status === 'object') ? item.status.status : item.status;
                return statusId === 26;
              })
              .sort((a, b) => {
                // Сортировка по дате
                return new Date(a.date) - new Date(b.date);
              })
              .map(i => this.toSelectableItem(i));
          // Уточненный план
          response = await fetch(
              `/api/budget-execution-utoch?region=${regionCode}&year=${year}`
          );
          const utochData = await response.json();
          this.listUtoch = utochData
              .filter(item => {
                // Проверяем статус (может быть как числом, так и объектом со свойством id)
                const statusId = (item.status && typeof item.status === 'object') ? item.status.status : item.status;
                return statusId === 26;
              })
              .sort((a, b) => {
                // Сортировка по дате
                return new Date(a.date) - new Date(b.date);
              })
              .map(i => this.toSelectableItem(i));
          // Заявки АБП
          if (this.accessLevels && this.accessLevels.position) {
            const response = await fetch(
                `/api/budget-execution-alteration-abp-request/list?region=${regionCode}&dateBegin=${dateFrom}&dateEnd=${dateTo}&level=${this.accessLevels.position.toUpperCase()}`
            );
            const abpData = await response.json();
            if (this.isAbpMode) {
                this.listABP = abpData.filter(item => {
                    return item.id === this.currentAlteration.id;
                }).map(i => this.toSelectableItem(i));
            } else if (this.isAbpByExpenseMode) {
                // загружаем все заявки/справки АБП; по справке (расходы) их фильтрует readyABPList
                this.listABP = abpData
                    .sort((a, b) => {
                        // Сортировка по дате
                        return new Date(a.date) - new Date(b.date);
                    })
                    .map(i => this.toSelectableItem(i));
            } else {
                this.listABP = abpData
                    .filter(item => {
                        // Проверяем статус (может быть как числом, так и объектом со свойством id)
                        const statusId = (item.status && typeof item.status === 'object') ? item.status.status : item.status;
                        return statusId === this.callerTabStatus;
                    })
                    .sort((a, b) => {
                        // Сортировка по дате
                        return new Date(a.date) - new Date(b.date);
                    })
                    .map(i => this.toSelectableItem(i));
            }

          }
          this.preselectCurrentAlteration();

        } catch (error) {
          console.error("Ошибка при загрузке данных для выбора:", error);
        }
      },
      preselectCurrentAlteration() {
        // Массив всех списков заявок в модалке
        const allLists = [this.listABP, this.listExpenses, this.listIncome, this.listUtoch];

        allLists.forEach(list => {
          if (Array.isArray(list)) {
            list.forEach(item => {
              // Если ID совпадает с редактируемой заявкой — помечаем чекбокс
              if (item.id === this.currentAlteration.id) {
                this.$set(item, 'check', true);
              }
            });
          }
        });
      },
      onClose() {
        this.visible = false; // Это вызовет исправленный setter
      },
      /**
       * Обеспечивает выбор только одного элемента в списке
       * @param {Array} list - массив данных таблицы
       * @param {Object} selectedItem - объект, на котором кликнули
       */
      handleSingleSelect(list, selectedItem) {
        if (selectedItem.check) {
          list.forEach(item => {
            if (item !== selectedItem) {
              item.check = false;
            }
          });
        }
      },
      // Снять отметки с заявок/справок АБП, состав которых зависит от справки (расходы) и ГУ-отправителя
      uncheckAbpByExpenseList() {
        if (!this.isAbpByExpenseMode) return;
        (this.listABP || []).forEach(item => {
          item.check = false;
        });
      },
      // Сброс состояния блока отправителя (вызывается при каждом открытии модалки в режиме АБП)
      resetSenderState() {
        clearTimeout(this.senderUserSearchTimer);
        this.senderOrgs = [];
        this.senderOrgCode = null;
        this.senderOrgsLoaded = false;
        this.senderUsers = [];
        this.senderUser = null;
        this.senderUsersLoading = false;
      },
      // Загрузка списка ГУ-отправителей текущего пользователя для данной заявки
      loadSenderOrgs() {
        if (!this.currentAlteration) return;
        Ax(
            {
              url: '/api/budget-execution-alteration-isgp/sender-gu',
              method: 'GET',
              params: { requestId: this.currentAlteration.id }
            },
            (data) => {
              this.senderOrgs = toSenderOrgList(data);
              this.senderOrgsLoaded = true;
              // сразу выбираем первый ГУ, при нескольких пользователь может сменить его в списке
              // (список сотрудников подгрузится через watch senderOrgCode)
              if (this.senderOrgs.length) {
                this.senderOrgCode = this.senderOrgs[0].code;
              }
            },
            (error) => {
              this.senderOrgsLoaded = true;
              this.makeToast('danger', this.setText('errors.err'), this.setText('errors.sender_orgs') + ' ' + error.toString());
            }
        );
      },
      // Загрузка сотрудников выбранного ГУ по строке поиска (ФИО или ИИН, серверный поиск)
      loadSenderUsers(query) {
        if (!this.senderOrgCode) return;
        // счётчик запросов - защита от гонок, применяем только ответ последнего запроса
        const seq = ++this.senderUserSearchSeq;
        this.senderUsersLoading = true;
        const params = { orgCode: this.senderOrgCode };
        if (query) {
          params.search = query;
        }
        Ax(
            {
              url: '/api/budget-execution-alteration-isgp/sender-employees',
              method: 'GET',
              params
            },
            (data) => {
              if (seq === this.senderUserSearchSeq) {
                this.senderUsers = toSenderUserList(data);
              }
            },
            (error) => {
              this.makeToast('danger', this.setText('errors.err'), this.setText('errors.sender_users') + ' ' + error.toString());
            },
            () => {
              if (seq === this.senderUserSearchSeq) {
                this.senderUsersLoading = false;
              }
            }
        );
      },
      // Поиск сотрудника в multiselect - debounce 300мс, чтобы не дёргать сервер на каждое нажатие клавиши
      onSenderUserSearch(text) {
        clearTimeout(this.senderUserSearchTimer);
        this.senderUserSearchTimer = setTimeout(() => {
          this.loadSenderUsers((text || '').trim());
        }, 300);
      },
      // Промис-обёртка над Ax: resolve(data) при 2xx, reject(I18nTemplate) при ошибке
      axRequest(config) {
        return new Promise((resolve, reject) => {
          Ax(config, data => resolve(data), error => reject(error));
        });
      },
      async onSend() {
        // Собираем элементы, у которых установлен флаг check, вместе с введёнными вручную датами
        const selectedItems = [
          ...this.readyExpensesList.filter(item => item.check),
          ...this.readyIncomeList.filter(item => item.check),
          ...this.readyUtochList.filter(item => item.check),
          ...this.readyABPList.filter(item => item.check)
        ];

        if (!selectedItems.length) {
          // Опционально: добавить уведомление, если ничего не выбрано
          return;
        }

        // Валидация: обе даты должны быть в пределах с начала текущего года по текущий день
        const hasInvalidDate = selectedItems.some(item =>
            !this.isDateAllowed(item.agreementDate) || !this.isDateAllowed(item.requestDate)
        );
        if (hasInvalidDate) {
          this.makeToast('danger', this.setText('errors.err'), this.setText('errors.date_out_of_range'));
          return;
        }

        // В режимах с отправителем номер (введённый вручную в таблице) обязан быть целым положительным числом
        if (this.isSenderMode) {
          const hasInvalidNumber = selectedItems.some(item =>
              !(Number.isInteger(Number(item.number)) && Number(item.number) > 0)
          );
          if (hasInvalidNumber) {
            this.makeToast('danger', this.setText('errors.err'), this.setText('errors.number_invalid'));
            return;
          }
        }

        // Изменённые номер/основание (относительно исходных значений) - сохраняются отдельным эндпоинтом requisites
        const requisites = this.isSenderMode ? selectedItems
            .map(item => {
              const change = { requestId: item.id };
              if (Number(item.number) !== Number(item.originalNumber)) change.number = Number(item.number);
              const description = (item.description || '').trim();
              if (description !== (item.originalDescription || '').trim()) change.description = description;
              return change;
            })
            .filter(change => change.number !== undefined || change.description !== undefined) : [];

        // Контракт для backend (см. также newAlterationForm.vue / UtochPlanForm.vue):
        // PUT /api/budget-execution-alteration/requisites — тело: массив изменённых номеров/оснований
        // [{ requestId, number, description }] (передаются только изменённые поля), выполняется до send-batch;
        // POST /api/budget-execution-alteration-isgp/send-batch?sendIsgp=true — тело: массив
        // [{ requestId, agreementDate: <мс>, requestDate: <мс> }], даты - unix timestamp в миллисекундах;
        // в режимах с отправителем в каждом элементе дополнительно передаются senderOrgCode и senderUserId
        // (number/description в send-batch больше не передаются - у них отдельный эндпоинт requisites)
        const items = selectedItems.map(item => {
          const entry = {
            requestId: item.id,
            agreementDate: moment(item.agreementDate).valueOf(),
            requestDate: moment(item.requestDate).valueOf()
          };
          if (this.isSenderMode) {
            entry.senderOrgCode = this.senderOrgCode;
            entry.senderUserId = this.senderUser.userId;
          }
          return entry;
        });

        this.sending = true;
        try {
          if (requisites.length) {
            // номер/основание сохраняются отдельным методом до отправки в ИС КК
            await this.axRequest({ url: '/api/budget-execution-alteration/requisites', method: 'PUT', data: requisites });
            // сохранённые значения становятся исходными - при повторной отправке (если send-batch упадёт) не сохраняем их снова
            selectedItems.forEach(item => {
              item.originalNumber = item.number;
              item.originalDescription = (item.description || '').trim();
            });
          }
          await this.axRequest({ url: '/api/budget-execution-alteration-isgp/send-batch', method: 'POST', params: { sendIsgp: true }, data: items });
          this.makeToast('success', this.setText('message'), this.setText('isgp_sender.sent'));
          this.$emit('sent', items);
          this.visible = false;
        } catch (error) {
          // модалку не закрываем - пользователь должен увидеть ошибку и иметь возможность исправить данные
          if (error && error.key === 'modules.budgetExecutionAlteration.error.requestNumberAlreadyExists') {
            this.makeToast('danger', this.setText('errors.err'), this.setText('errors.number_exists'));
          } else {
            this.makeToast('danger', this.setText('errors.save'), String(error));
          }
        } finally {
          this.sending = false;
        }
      },
    },
    created() {
      for (const item of this.larTableFields) {
        if (item.hasOwnProperty(`name_${i18nService.locale}`)) {
          Object.defineProperty(item, 'label', {
            configurable: true,
            get: function () {
              if (!item.hasOwnProperty(`name_${i18nService.locale}`)) {
                return item.value[`name_${i18nService.locale}`];
              } else {
                return item[`name_${i18nService.locale}`];
              }
            }
          });
        }
      }
    },
};
</script>
<style scoped lang="scss">
::v-deep .isgp-editable-date-input {
    background-color: #e6f4ff !important;
    width: 100%;
    min-width: 0;
    box-sizing: border-box;
}
.isgp-editable-input {
  background-color: #e6f4ff !important;
}
.isgp-sender-block {
  width: 100%;
  padding: 12px;
  margin-bottom: 16px;
  display: flex;
  flex-direction: column;
  // выпадающий список сотрудников должен быть поверх вкладок таблиц ниже:
  // у .tabs-in-tabs .nav-tabs глобально z-index: 1001 (assets/scss/basics/tabs.scss)
  position: relative;
  z-index: 1002;

  &__field {
    width: 100%;
    margin-bottom: 12px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  &__label {
    display: block;
    font-weight: 700;
    font-size: 12px;
    margin-bottom: 4px;
  }

  &__error {
    font-size: 12px;
    color: #dc3545;
    margin-top: 4px;
  }
}
.isgp-sender-user-option {
  &__org {
    font-size: 11px;
    color: #6c757d;
  }
}
.add_modal {
  width:100%;
  height:100%;
  .icon-btn{
    width: 20px;
    height: 20px;
    padding: 5px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-shadow: none !important;
    background-color: transparent;
    border: 1px solid rgba(28, 42, 62, 1);
    border-radius: 50%;
    margin: 0;
  }
  .icon-btn i{
    font-size: 0.4444444444rem;
    color: rgba(28, 42, 62, 1);
  }
  &__body {
    background-color: #f7f9fc;
    border: 1px solid #d3dbe3;
    border-radius: 5px;
    margin-bottom: 23px;
  }

  &__title {
    font-weight: 600;
    font-size: 14px;
    margin-bottom: 26px;
  }

  &__item {
    display: flex;
    align-items: center;
    height: 50px;
    border: 1px solid #d3dbe3;
    justify-content: space-between;
    padding: 0 10px 0 16px;

    &__title {
      font-weight: 500;
      font-size: 14px;
      color: #6087a0;
    }
  }
}
.scrolable {
  height: 100%;
  max-height: 500px;
  flex: 1; /* Occupy remaining vertical space */
  overflow-y: scroll /* Enable vertical scrolling if content overflows */
}
</style>
